//#region src/language_code.ts
var LanguageCode = /* @__PURE__ */ function(LanguageCode) {
	LanguageCode["EN_US"] = "en-us";
	LanguageCode["AR_SA"] = "ar-sa";
	LanguageCode["EN_GB"] = "en-gb";
	LanguageCode["FR_CA"] = "fr-ca";
	LanguageCode["ES_US"] = "es-us";
	LanguageCode["ZH_CN"] = "zh-cn";
	LanguageCode["JA_JP"] = "ja-jp";
	LanguageCode["KO_KR"] = "ko-kr";
	LanguageCode["PT_BR"] = "pt-br";
	LanguageCode["VI_VN"] = "vi-vn";
	LanguageCode["DE_DE"] = "de-de";
	LanguageCode["IT_IT"] = "it-it";
	return LanguageCode;
}(LanguageCode || {});
//#endregion
export { LanguageCode };

//# sourceMappingURL=language_code.js.map